import React from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";
import FeelingProud from "./FeelingProud";

export default function Greeting(props) {
  const theme = props.theme;

  return (
    <Fade bottom duration={2000} distance="50px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-copy">
            <span className="eyebrow">Senior Tech Leader • Product Engineer</span>
            <h1 className="greeting-text" style={{ color: theme.text }}>
              {greeting.title}
            </h1>
            <h2 className="greeting-text-p subTitle" style={{ color: theme.text }}>
              {greeting.nickname}
            </h2>

            <p className="greeting-text-sub" style={{ color: theme.secondaryText }}>
              {greeting.subTitle}
            </p>

            <div className="greeting-tags">
              {greeting.aiStack.map((item) => (
                <span key={item} className="tag-pill" style={{ color: theme.text, borderColor: theme.highlight }}>
                  {item}
                </span>
              ))}
            </div>

            <div className="button-greeting-div">
              <Button text="View Experience" href="#experience" theme={theme} />
              <Button text="Connect on LinkedIn" newTab={true} href="https://www.linkedin.com/in/ramesh-kumar-147b3249/" theme={theme} />
            </div>

            <div className="greeting-stats">
              {greeting.heroStats.map((stat) => (
                <div className="stat-card" key={stat.label} style={{ borderColor: theme.highlight, background: `${theme.highlight}22` }}>
                  <strong style={{ color: theme.text }}>{stat.value}</strong>
                  <span style={{ color: theme.secondaryText }}>{stat.label}</span>
                </div>
              ))}
            </div>

            <SocialMedia theme={theme} />
          </div>

          <div className="greeting-visual">
            <FeelingProud theme={theme} />
          </div>
        </div>
      </div>
    </Fade>
  );
}
